// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jcPi","colBig":"styles_colBig__2aka1","colSmall":"styles_colSmall__1t_QJ"};